module.exports = __webpack_public_path__ + "static/media/14.106.15ddab33.webp";